import type {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {ActionButton} from 'components/PageHeader';

export const NewNoteButton: FC = () => {
  const navigate = useNavigate();

  return (
    <ActionButton
      label="New Note"
      onClick={() => navigate('/documentation/notes/new')}
      testId="create-note-button"
    />
  );
};
